import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";

import { DataGrid } from "@mui/x-data-grid";
import LoadingIcon from "../../../../components/common/LoadingIcon";

//CSS
import "../../DoctorHomeDiary.css";
import "../../../../overall.css";

// API Import
import { postNewStudy } from "../../../../API/HomeDiaryCalls";

const steps = [
  "Study Information",
  "Customizable Features",
  "Add Patients",
  "Create Study",
];
const steps_desc = [
  "Enter Study Information",
  "Select Customizable Features",
  "Select Patients",
  "Review Study Summary",
];

const StyledOrderedList = styled("ol")(({ theme }) => ({
  listStyleType: "decimal",
  paddingLeft: theme.spacing(4),
}));

const StyledListItem = styled("li")(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

//TODO: Matt -> Refactor study container and break up into components
function NewStudyModal(props) {
  const [activeStep, setActiveStep] = useState(0);

  // Form data
  const [studyName, setStudyName] = useState("");
  const [studyNameError, setStudyNameError] = useState(false);
  const [studyNameHelp, setStudyNameHelp] = useState("");
  const [studyType, setStudyType] = useState("Single");
  const [studyDescription, setStudyDescription] = useState("");
  const [finishButtonDisabled, setFinishButtonDisabled] = useState(false);
  
  // Table states/variables
  const [tableRows, setTableRows] = useState([]);
  const [tableSelectedIDs, setTableSelectedIDs] = useState(new Set());
  const [createdStudiesCount, setCreatedStudiesCount] = useState(0); // NEW: Track created studies

  let columns = [
    // { field: 'patientNumber', headerName: 'Patient Number', width: 100 },
    { field: "firstLast", headerName: "First Name, Last Name", width: 350 },
  ];

  useEffect(() => {
    var filterPatients = [];
    if (props.patients && Array.isArray(props.patients)) {
      Object.values(props.patients).forEach((patient, index) => {
        if ((patient.givenName || patient.surname) && patient.patientID !== -1) {
          //note: patients with -1 id break server
          filterPatients.push({
            id: index,
            patientNumber: patient.patientID,
            firstLast: patient.givenName + " " + patient.surname,
            dateEnrolled: patient.startDate,
            status: "Active Study",
            authID: patient.azureAuthGUID,
          });
        }
      });
    }
    setTableRows(filterPatients);
  }, [props.patients, tableSelectedIDs]);

  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const handleStudyNameChange = (event) => {
    if (studyNameError) {
      setStudyNameError(false);
      setStudyNameHelp("");
    }
    setStudyName(event.target.value);
  };
  const handleStudyTypeChange = (event) => {
    setStudyType(event.target.value);
  };
  const handleStudyDescriptionChange = (event) => {
    setStudyDescription(event.target.value);
  };

  const handleNext = () => {
    // Step 0: Validate study name
    if (activeStep === 0) {
      if (studyName === "") {
        setStudyNameError(true);
        setStudyNameHelp("Required Field");
        return;
      }
    }
    
    // Step 3: Create study (async operation)
    if (activeStep === 3) {
      // Let createStudy handle step advancement on success
      createStudy();
      return; // Prevent advancing before API completes
    }
    
    // All other steps: advance normally
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const clearPreviousStudy = () => {
    setStudyName("");
    setStudyNameError(false);
    setStudyNameHelp("");
    setStudyType("Single");
    setStudyDescription("");
    setActiveStep(0);
    setFinishButtonDisabled(false);
    setTableSelectedIDs(new Set()); // Clear selected patients
  };

  function showPatients() {
    var idSet = new Set(tableSelectedIDs);
    var listPatients = [];
    tableRows.forEach((value) => {
      if (idSet.has(value.id)) {
        listPatients.push(value.firstLast);
      }
    });
    // setSelectedPatients(savePatients);
    return listPatients.map((value, index) => {
      return (
        <StyledListItem className="body-text-size dark-grey" key={index}>
          {value}
        </StyledListItem>
      );
    });
  }

  async function createStudy() {
    var idSet = new Set(tableSelectedIDs);
    var listPatients = [];
    tableRows.forEach((value) => {
      if (idSet.has(value.id)) {
        listPatients.push({
          patientID: value.patientNumber,
          startDate: "2021-12-14T08:31:00.057Z",
          endDate: new Date().toISOString(),
        });
      }
    });
    
    setFinishButtonDisabled(true);
    
    try {
      // Call API and get result
      const result = await postNewStudy(0, studyName, studyDescription, listPatients);
      
      if (result.success) {
        // Only increment count on SUCCESS
        setCreatedStudiesCount((prev) => prev + 1);
        console.log("Study created successfully!");
        // ← ADD THIS: Only advance step on success
        setActiveStep((prev) => prev + 1);
      } else {
        // Handle API-level errors
        throw new Error(result.error || "Failed to create study");
      }
      
    } catch (error) {
      console.error("Failed to create study:", error);
      alert(`Failed to create study: ${error.message || 'Unknown error occurred'}`);
      // Don't advance step on error - user can retry
    } finally {
      setFinishButtonDisabled(false);
    }
  }

  const handleNewStudyClose = () => {
    if (typeof props.setNewStudyModalOpen === "function") {
      props.setNewStudyModalOpen(false);

      // Only reload if studies were created
      if (createdStudiesCount > 0 && props.handlePostStudy) {
        props.handlePostStudy();
      }

      // Reset everything
      clearPreviousStudy();
      setCreatedStudiesCount(0);
    }
  };

  function modalContent() {
    if (activeStep === 0) {
      return (
        <div>
          <TextField
            required
            id="outlined-study-name"
            label="Study Name"
            onChange={handleStudyNameChange}
            value={studyName}  // Use value instead of defaultValue
            error={studyNameError}
            helperText={studyNameHelp}
            style={{ width: "243px" }}
          />

          <span className="mrl-12"></span>

          <FormControl>
            <InputLabel id="study-type-select-label">Study Type</InputLabel>
            <Select
              labelId="study-type-select-label"
              id="study-type-select"
              value={studyType}
              label="Study Type"
              onChange={handleStudyTypeChange}
              style={{ width: "243px" }}>
              <MenuItem value={"Single"}>Single</MenuItem>
              <MenuItem value={"Double"}>Double</MenuItem>
            </Select>
          </FormControl>

          <div className="mrt-12">
            <TextField
              id="outlined-study-description"
              label="Study Description"
              multiline
              rows={12}
              onChange={handleStudyDescriptionChange}
              value={studyDescription}  // Use value instead of defaultValue
              style={{ width: "500px" }}
            />
          </div>
        </div>
      );
    } else if (activeStep === 1) {
      return (
        <div className="nsModal-container">
          <div>Select Customizable Features: (Disabled) </div>
          <div className="nsModal-customFeaturesContainer">
            <div className="nsModal-checkboxRow">
              <div>Symptom Logging</div>
              <Checkbox {...label} disabled />
            </div>
            <div className="nsModal-checkboxRow">
              <div>Cold/Flu</div>
              <Checkbox {...label} disabled />
            </div>
            <div className="nsModal-checkboxRow">
              <div>Pain</div>
              <Checkbox {...label} disabled />
            </div>
            <div className="nsModal-checkboxRow">
              <div>Stomach Bug</div>
              <Checkbox {...label} disabled />
            </div>
            <div>Add Other: </div>
            <div className="nsModal-checkboxRow">
              <div>Food Logging</div>
              <Checkbox {...label} disabled />
            </div>
            <div className="nsModal-checkboxRow">
              <div>Water Intake Tracking</div>
              <Checkbox {...label} disabled />
            </div>
            <div className="nsModal-checkboxRow">
              <div>Period Irregularity Tracking</div>
              <Checkbox {...label} disabled />
            </div>
          </div>
        </div>
      );
    } else if (activeStep === 2) {
      if (tableRows !== undefined && tableRows.length > 0) {
        return (
          <div style={{ height: "100%", width: "100%" }}>
            <DataGrid
                    // sx={{
                    //     '.MuiCheckbox-colorPrimary.Mui-checked': {
                    //         color: 'red'
                    //     }
                    // }}
              rows={tableRows}
              columns={columns}
              checkboxSelection
              pageSize={1}
              autoHeight
              // autoPageSize={true}
              selectionModel={tableSelectedIDs}
              onRowSelectionModelChange={(ids) => {
                setTableSelectedIDs(ids);
                  // const tempArray = [];
                  // const selectionModel = [];
                  // tableRows.forEach(element => {
                  //     if (element.id !== undefined) {
                  //         if (selectedIDs.has(element.id)) {
                  //             tempArray.push(element);
                  //             selectionModel.push(element.id);
                  //         }
                  //     }
                  // });
                  // setSelectedPatients(tempArray);
                  // setTableSelectionModel(selectionModel);
              }}
            />
          </div>
        );
      } else {
        return (
          <div style={{ height: "100%", width: "100%", textAlign: "center", padding: "20px" }}>
            <LoadingIcon style={{ marginLeft: "15%" }} />
            <p className="body-text-size dark-grey mt-4">Loading patients...</p>
          </div>
        );
      }
    } else {
      return (
        <div className={"nsModal-cs-summaryContainer"}>
          <div className="body-text-size primary-blue mrb-8">
            Study Name:
            <span className="body-text-size dark-grey ps-1">{studyName}</span>
          </div>
          <div className="body-text-size primary-blue mrb-8">
            Study Type:
            <span className="body-text-size dark-grey ps-1">{studyType}</span>
          </div>
          <div className="body-text-size primary-blue mrb-8">
            Total Number of Patients:
            <span className="body-text-size dark-grey ps-1">
              {tableSelectedIDs.length}
            </span>
          </div>
          <div className="body-text-size primary-blue mrb-8">
            Patients:
            <StyledOrderedList>{showPatients()}</StyledOrderedList>
          </div>
        </div>
      );
    }
  }

  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);

  const label = { inputProps: { "aria-label": "Checkbox" } };

  const body = (
    <div style={modalStyle} className="newStudyModal box-container">
      {/* Close Button (X) */}
      <IconButton
        aria-label="close"
        onClick={handleNewStudyClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}>
        <CloseIcon />
      </IconButton>

      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>

      <div className="nsModal-content">
        {activeStep === steps.length ? (
          <React.Fragment>
            <div className="dark-grey body-text-size">
              All steps completed - you&apos;re finished
            </div>
            {createdStudiesCount > 0 && (
              <div className="text-green-600 body-text-size mt-2">
                ✓ {createdStudiesCount} {createdStudiesCount === 1 ? 'study' : 'studies'} created successfully!
              </div>
            )}
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
            </Box>
            <Box>
              <Button
                onClick={clearPreviousStudy}
                variant="contained"
                sx={{
                  "backgroundColor": "#5fbdd6",
                  "color": "white",
                  "borderRadius": "10px",
                  "textTransform": "none",
                  "padding": "8px 24px",
                  "&:hover": {
                    backgroundColor: "#4a9db0",
                  },
                }}>
                Create Another Study
              </Button>
            </Box>
            <Box sx={{ flex: "1 1 auto", mt: 1 }}>
              <Button
                onClick={handleNewStudyClose}
                variant="outlined"
                sx={{
                  "color": "#727176",
                  "border": "2px solid #727176",
                  "borderRadius": "10px",
                  "textTransform": "none",
                  "padding": "8px 24px",
                  "&:hover": {
                    border: "2px solid #727176",
                    backgroundColor: "rgba(114, 113, 118, 0.04)",
                  },
                }}>
                {createdStudiesCount > 0 ? 'Close & Refresh' : 'Close'}
              </Button>
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="row">
              <div className="sub-title-size sub-title mrb-12 mrt-24">
                Step {activeStep + 1}
              </div>
              <div className="sub-title-size body-text mrb-12 mrt-24 mrl-12">
                {steps_desc[activeStep]}
              </div>
            </div>

            {modalContent()}
          </React.Fragment>
        )}
      </div>

      <div className="nsModal-NextAndBackButton">
        <Box sx={{ display: "flex", flexDirection: "row", pt: 2, justifyContent: "center", alignItems: "center", gap: 2 }}>
          <Button
            variant="outlined"
            disabled={activeStep === 0 || activeStep === steps.length} // CHANGED: Also disable on completion step
            onClick={handleBack}
            sx={{
              "color": "#727176",
              "border": "2px solid #727176",
              "borderRadius": "10px",
              "textTransform": "none",
              "marginLeft": "-10px",
              "padding": "8px 24px",
              "&:hover": {
                border: "2px solid #727176",
                backgroundColor: "rgba(114, 113, 118, 0.04)",
              },
              "&.Mui-disabled": {
                border: "2px solid #f0f0f0",
                color: "#d0d0d0",
              },
            }}>
            Back
          </Button>
          {/* CHANGED: Hide Next/Finish button when on completion step */}
          {activeStep < steps.length && (
            <Button
              variant="contained"
              onClick={handleNext}
              disabled={finishButtonDisabled}
              sx={{
                "backgroundColor": "#5fbdd6",
                "color": "white",
                "borderRadius": "10px",
                "textTransform": "none",
                "padding": "8px 24px",
                "&:hover": {
                  backgroundColor: "#4a9db0",
                },
                "&.Mui-disabled": {
                  backgroundColor: "#f0f0f0",
                  color: "#d0d0d0",
                },
              }}>
              {activeStep === steps.length - 1 ? "Finish" : "Next"}
            </Button>
          )}
        </Box>
      </div>
    </div>
  );

  return (
    <Modal
      open={props.newStudyModalOpen}
      onClose={handleNewStudyClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description">
      {body}
    </Modal>
  );
}

export default NewStudyModal;
